"use strict";

angular.module("core")
.service("RequestSupportService", function($http, appConfig) {
    this.post = function(data) {
        return $http.post(appConfig.API_SERVER + "/auth/request-support/", data);
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/support-assistant/request-support.service.js
// module id = 425
// module chunks = 0